// src/components/layouts/StaticImageMedia.tsx
import React from 'react';
import { AbsoluteFill, Img } from 'remotion';

export const StaticImageMedia: React.FC<{
  imageUrl?: string;
  audio: React.ReactNode;
}> = ({ imageUrl, audio }) => (
  <AbsoluteFill style={{ overflow: 'hidden', backgroundColor: '#000' }}>
    {imageUrl ? (
      <Img src={imageUrl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    ) : (
      <div
        data-testid="placeholder"
        style={{ width: '100%', height: '100%', backgroundColor: '#1f2937', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: 32, fontFamily: 'system-ui,-apple-system,sans-serif' }}
      >
        🖼️
      </div>
    )}
    {audio}
  </AbsoluteFill>
);
